import { z } from 'zod'
import { BaseFilter } from './base'

export type DateRangeFilterValue = {
  start: string
  end: string
}

export class DateRangeFilter extends BaseFilter<DateRangeFilterValue> {
  static readonly schema = z.object({
    start: z.string().datetime(),
    end: z.string().datetime(),
  })

  parse(urlValue: string): DateRangeFilterValue | null {
    if (!urlValue) {return null}
    try {
      const jsonValue = JSON.parse(urlValue)
      return this.safeParse(jsonValue)
    } catch {
      return null
    }
  }

  serialize(value: DateRangeFilterValue): string {
    return JSON.stringify(value)
  }

  getSchema() {
    return DateRangeFilter.schema
  }
}
